var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHintPointerinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.414 18H0v7h25V0L8.603 15.534A9 9 0 0 1 2.413 18Z",
  fill: "#E5F8F5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 19v-1h2.414a9 9 0 0 0 6.19-2.466L25 0v25h-1V2.325L9.291 16.259A10 10 0 0 1 2.414 19H0Z",
  fill: "#0FB799"
})));
export default SvgHintPointerinline;